<template>
  <v-text-field
    :label="label"
    :value="formattedValue"
    @input="onInput"
    @keydown="restrictInput"
    :disabled="disabled"
    :readonly="readonly"
    :rules="rules"
    :dense="dense"
    hide-details
    type="text"
    :class="['app-text-field app-input-bordered', { 'remove-top-spacing': removeTopSpacing }]"
    @paste.stop.prevent="onPaste($event)"
  />
</template>

<script>
import { sanitizePastedNumeric } from "@/helpers/numbers";

export default {
  name: "FormattedCurrencyInput",
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    label: String,
    disabled: Boolean,
    readonly: Boolean,
    removeTopSpacing: Boolean,
    dense: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    maximumFractionDigits: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    formattedValue() {
      const val = Number(this.value);
      if (this.value === null || this.value === undefined || this.value === "") return "";
      return isNaN(val) ? "" : `$${val.toLocaleString("en-US", { maximumFractionDigits: this.maximumFractionDigits })}`;
    },
  },
  methods: {
    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData)?.getData("text") || "";
      const numStr = sanitizePastedNumeric(text, true);
      const num = parseInt(numStr, 10);
      this.$emit("input", Number.isNaN(num) ? null : num);
    },
    onInput(val) {
      const digitsOnly = val.replace(/[^\d]/g, "");
      const num = parseInt(digitsOnly, 10);
      this.$emit("input", isNaN(num) ? null : num);
    },
    restrictInput(event) {
      const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
      if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) return;

      const isDigit = /^\d$/.test(event.key);
      if (!isDigit) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.remove-top-spacing {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
